export default () => {

  const $header = $('.c-header')

  if ($header.length) {
    const setHeaderHeight = () => {
      document.documentElement.style.setProperty('--lrg-headers-height', `${$header.outerHeight()}px`)
    }

    setHeaderHeight()

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(setHeaderHeight).observe($header[0])
    } else {
      $(window).on('resize orientationchange', setHeaderHeight)
    }
  }

  $('.js-header__loginLink--logout').on('click', e => {
    e.preventDefault()
    $('.js-header__logoutForm').submit()
  })

  const $body = $('body')
  $body.append($('<div class="sideMenuOverlay"></div>'))
  const $overlay = $('.sideMenuOverlay')

  const $sidenav = $('.js-sidenav')

  $sidenav.addClass('c-sidenav--ready')

  $('.js-sidenav__trigger').on('click', () => {
    $sidenav.addClass('c-sidenav--active')
    $overlay.addClass('sideMenuOpened')
    $body.addClass('sideMenuOpened')
  })

  $('.js-sidenav__closeIconWrapper').on('click', () => {
    closeSideMenu()
  })

  $(document).on('click', '.sideMenuOverlay', ( )=> {
    closeSideMenu()
  })

  function closeSideMenu() {
    $sidenav.removeClass('c-sidenav--active')
    $overlay.removeClass('sideMenuOpened')
    $body.removeClass('sideMenuOpened')
  }
}
